export enum ImageShape {
  SQUARE = 'SQUARE',
  CIRCLE = 'CIRCLE',
}
